"use client";
import { isFeatureOn } from "@/config/feature-flag";
import { createContext } from "react";

export type FeatureFlagContextType = {
  isFlagOn?: (flag: string) => Promise<boolean>;
};

export const FeatureFlagContext = createContext<FeatureFlagContextType | null>(
  null
);

export default function FeatureFlagProvider(params: { children: JSX.Element }) {
  const isFlagOn = async (flag: string) => {
    return await isFeatureOn(flag);
  };

  const values = { isFlagOn };

  return (
    <FeatureFlagContext.Provider value={values}>
      {params.children}
    </FeatureFlagContext.Provider>
  );
}
